import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RevenueRecoveryDetails } from 'src/app/core/models/admin/location-config.model';
import {
  CONSTS,
  REV_RECOVERY_TYPE,
} from './revenue-recovery-setting.constants';

@Component({
  selector: 'app-revenue-recovery-setting',
  templateUrl: './revenue-recovery-setting.component.html',
  styleUrl: './revenue-recovery-setting.component.scss',
  standalone: false,
})
export class RevenueRecoverySettingComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) initialVals!: RevenueRecoveryDetails;
  @Input({ required: true }) unit!: 'I' | 'M';

  readonly CONSTANTS = CONSTS;
  readonly TYPE = REV_RECOVERY_TYPE;

  get getPackageForm() {
    return this.form.get('revRecoveryPackage') as FormGroup;
  }

  get getPalletForm() {
    return this.form.get('revRecoveryPallet') as FormGroup;
  }
}
